import { render, staticRenderFns } from "./material.vue?vue&type=template&id=554025b5&scoped=true&"
import script from "./material.vue?vue&type=script&lang=js&"
export * from "./material.vue?vue&type=script&lang=js&"
import style0 from "./material.vue?vue&type=style&index=0&id=554025b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554025b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554025b5')) {
      api.createRecord('554025b5', component.options)
    } else {
      api.reload('554025b5', component.options)
    }
    module.hot.accept("./material.vue?vue&type=template&id=554025b5&scoped=true&", function () {
      api.rerender('554025b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/material.vue"
export default component.exports